import { memo } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'

type HistoryTab = 'transactions' | 'otc'

export const HistoryTabs = memo(function HistoryTabs({
  active,
}: {
  active: HistoryTab
}) {
  const { t } = useTranslation()
  const { enableOtc } = useFeatureFlags()

  if (!enableOtc) {
    return null
  }

  return (
    <div
      className="mb-6 flex gap-6 border-b border-gray-300 dark:border-gray-700"
      role="tablist"
      aria-label={t('dashboardHistory.tabs.label')}
      data-testid="history-tabs"
    >
      <Link
        to="/History"
        role="tab"
        aria-selected={active === 'transactions'}
        className={clsx(
          'pb-2 text-sm font-medium uppercase tracking-wide transition-colors',
          active === 'transactions'
            ? 'border-b-2 border-black text-black dark:border-white dark:text-white'
            : 'text-gray-500 hover:text-black dark:text-gray-400 dark:hover:text-white'
        )}
        data-testid="history-tab-transactions"
      >
        {t('dashboardHistory.tabs.transactions')}
      </Link>
      <Link
        to="/otc-requests"
        role="tab"
        aria-selected={active === 'otc'}
        className={clsx(
          'pb-2 text-sm font-medium uppercase tracking-wide transition-colors',
          active === 'otc'
            ? 'border-b-2 border-black text-black dark:border-white dark:text-white'
            : 'text-gray-500 hover:text-black dark:text-gray-400 dark:hover:text-white'
        )}
        data-testid="history-tab-otc"
      >
        {t('dashboardHistory.tabs.otcRequests')}
      </Link>
    </div>
  )
})
